const photos = [
  {
    alt: "réparation fenêtre Bois Strasbourg",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/6d237f782373e8b9b4c897af9248880c.webp",
  },
  {
    alt: "mécanisme fenêtre Bois Bas-Rhin",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/92f937c554b00666090e4f19b595976b.jpeg",
  },
  {
    alt: "crémone fenêtre Bois Schiltigheim",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/73131c375375b425d22a36886a752302.jpeg",
  },
  {
    alt: "gond fenêtre Bois Haguenau",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/be6c1f97d5ea7df8bcbfbe3be74c7a73.jpeg",
  },
  {
    alt: "poignée fenêtre Bois Illkirch",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/c450ec3e7af2cc1bbbd1474556446aa2.jpeg",
  },
  {
    alt: "réglage fenêtre Bois Strasbourg centre",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/2f2dd77280f03252099b15c689ab9334.jpeg",
  },
];

export default function Gallery() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="max-w-4xl">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Galerie photos — réparation fenêtre Bois
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {photos.map((photo, i) => (
            <div
              key={i}
              className="aspect-[4/3] rounded-2xl overflow-hidden border border-rose-200 bg-rose-50"
            >
              <img
                src={
                  photo.src
                    ? photo.src
                    : `https://readdy.ai/api/search-image?query=${encodeURIComponent(photo.prompt)}&width=${photo.w}&height=${photo.h}&seq=${photo.seq}&orientation=landscape`
                }
                alt={photo.alt}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}